// @ts-nocheck
// Your entire JS file is now ignored by the TypeScript checker
import { ThemeEvents, CartUpdateEvent } from "@theme/events";

class RechargeBundle extends HTMLElement {
  constructor() {
    super();

    this.externalProductId = parseInt(this.getAttribute("shopify-product-id"));
    this.discountProducts = {
      onetime: this.getDiscountProductConfig("onetime"),
      subscription: this.getDiscountProductConfig("subscription"),
    };
    this.discountProduct = this.discountProducts.onetime.variantId;
    this.discountCode = this.getAttribute("shopify-discount-code");
    this.discountTitle = this.getAttribute("shopify-discount-product-title");
    this.discountImage = this.getAttribute("shopify-discount-product-image");
    this.bundleProductData = {};
    this.products = [];
    this.bundleProducts = [];
    this.maxPerProduct = null;
    this.bundleId = "";
    this.boxes = [];
    this.priceRule = "fixed";
    this.quantityMin = null;
    this.quantityMax = null;
    this.isDynamicBundle = false;
    this.shop = window?.Shopify?.shop;
    this.form = this.querySelector("#bundle-form");
    this.quantityInputs = this.querySelectorAll(".quantity-input");
    this.sellingPlan = "";
    this.sellingPlanText = "";
    this.productGrid =
      this.querySelector(".product-grid") || document.querySelector(".product-grid");
    this.crossSellCollection = null;
    this.addonsCollection = null;
    this.addonSelections = new Map();
    this.addonCatalog = [];
    this.addonModal = null;
    this.addonGrid = null;
    this.addonPrevBtn = null;
    this.addonTotal = 0;
    this.addonNextBtn = null;
    this.lastBundleTotalCents = 0;
    // Experiment BM-151
    this.existingCartTotalCents = parseInt(this.getAttribute("data-cart-total-cents"), 10) || 0;
    // End Experiment BM-151
    this.spinner = `<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" style="display: block;
    width: 26px;
    height: 26px;
    transform-box: fill-box;
    color: #2c3d80 !important;
    margin: auto;">
        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30" style="transform-origin: center; stroke:#2c3d80 !important;"></circle>
      </svg>`;
    this.rechargeLoader();
  }

  getDiscountProductConfig(type) {
    const attrPrefix =
      type === "subscription"
        ? "shopify-discount-product-subscription"
        : "shopify-discount-product-onetime";
    const legacyPrefix = "shopify-discount-product";
    const variantRaw =
      this.getAttribute(attrPrefix) || (type === "onetime" ? this.getAttribute(legacyPrefix) : "");
    const variantId = Number.parseInt(variantRaw, 10);

    return {
      variantId: Number.isFinite(variantId) ? variantId : null,
      title:
        this.getAttribute(`${attrPrefix}-title`) ||
        (type === "onetime" ? this.getAttribute(`${legacyPrefix}-title`) : "") ||
        "",
      image:
        this.getAttribute(`${attrPrefix}-image`) ||
        (type === "onetime" ? this.getAttribute(`${legacyPrefix}-image`) : "") ||
        "",
    };
  }

  getSelectedDiscountProduct() {
    const selectedPlan = this.getSelectedSchedulePlan();
    return selectedPlan ? this.discountProducts.subscription : this.discountProducts.onetime;
  }

  getFreeGiftThresholdCents() {
    const dollars = Number.parseFloat(this.getAttribute("shopify-free-gift-threshold") || "0");
    if (!Number.isFinite(dollars) || dollars <= 0) return 0;
    return Math.round(dollars * 100);
  }

  getCurrentBundleTotalCents() {
    return this.computeBundleTotalCents();
  }

  computeBundleTotalCents() {
    const getBasePriceDollars = () => {
      if (typeof window.getPfBundleBasePriceDollars === "function") {
        const fromUi = window.getPfBundleBasePriceDollars();
        if (Number.isFinite(fromUi)) return fromUi;
      }
      const selectedBox = this.querySelector(".box-card.selected");
      return parseFloat(selectedBox?.getAttribute("data-price") || "0") || 0;
    };
    const discountRaw = String(
      this.querySelector(".schedule-card.selected")?.getAttribute("data-discount") || "0"
    );
    const basePrice = getBasePriceDollars();
    const discountValue = parseFloat(String(discountRaw).replace("%", "")) || 0;
    const discounted = String(discountRaw).includes("%")
      ? basePrice * ((100 - discountValue) / 100)
      : Math.max(0, basePrice - discountValue);
    let addonExtra = 0;
    Array.from(this.addonSelections.values()).forEach((selection) => {
      addonExtra += (parseFloat(selection.price) || 0) * (parseInt(selection.quantity, 10) || 0);
    });
    const totalCents = Math.round((discounted + addonExtra) * 100);
    this.lastBundleTotalCents = totalCents;
    return totalCents;
  }

  isFreeGiftUnlocked(totalCents) {
    const threshold = this.getFreeGiftThresholdCents();
    if (threshold <= 0) return true;
    const total =
      totalCents != null && Number.isFinite(Number(totalCents))
        ? Number(totalCents)
        : this.getCurrentBundleTotalCents();
    return total >= threshold;
  }

  shouldIncludeFreeGift() {
    const discountProduct = this.getSelectedDiscountProduct();
    return !!(discountProduct?.variantId && this.isFreeGiftUnlocked());
  }

  getSelectedSchedulePlan() {
    const selectedSchedule = this.querySelector(".schedule-card.selected");
    if (selectedSchedule?.getAttribute("data-value") === "onetime") {
      return "";
    }
    return String(selectedSchedule?.getAttribute("data-plan") || "").trim();
  }

  getSelectedScheduleSelection() {
    const selectedSchedule = this.querySelector(".schedule-card.selected");
    if (!selectedSchedule) {
      return {
        value: "",
        label: "",
        planId: null,
      };
    }

    const value = String(selectedSchedule.getAttribute("data-value") || "").trim();
    const label = String(
      selectedSchedule.getAttribute("data-text") ||
        selectedSchedule.querySelector(".schedule-card__label")?.textContent ||
        ""
    ).trim();
    const rawPlan = String(selectedSchedule.getAttribute("data-plan") || "").trim();
    const parsedPlanId = Number.parseInt(rawPlan, 10);

    return {
      value,
      label,
      planId: Number.isFinite(parsedPlanId) ? parsedPlanId : null,
    };
  }

  extractIntervalKey(raw) {
    const text = String(raw || "")
      .toLowerCase()
      .trim();
    if (!text) return "";

    const everyMatch = text.match(/every\s*(\d+)\s*(day|days|week|weeks|month|months)/i);
    if (everyMatch) {
      const n = everyMatch[1];
      const unit = String(everyMatch[2] || "")
        .toLowerCase()
        .replace(/s$/, "");
      return `${n}-${unit}`;
    }

    const genericMatch = text.match(/(\d+)\s*[-_\s]*(day|days|week|weeks|month|months)/i);
    if (genericMatch) {
      const n = genericMatch[1];
      const unit = String(genericMatch[2] || "")
        .toLowerCase()
        .replace(/s$/, "");
      return `${n}-${unit}`;
    }

    return "";
  }

  resolveSellingPlanIdForProduct(productData, scheduleSelection, options = {}) {
    if (!productData || !scheduleSelection || scheduleSelection.value === "onetime") return null;

    const selectedLabel = String(scheduleSelection.label || "")
      .toLowerCase()
      .trim();
    const selectedValue = String(scheduleSelection.value || "")
      .toLowerCase()
      .trim();
    const selectedIntervalKey =
      this.extractIntervalKey(selectedLabel) || this.extractIntervalKey(selectedValue);
    const fromCard = Number.parseInt(String(scheduleSelection.planId || ""), 10);
    const allowCardFallback = options.allowCardFallback === true;

    /** @type {number[]} */
    const candidates = [];
    const groups = Array.isArray(productData.selling_plan_groups)
      ? productData.selling_plan_groups
      : [];

    groups.forEach((group) => {
      const plans = Array.isArray(group?.selling_plans) ? group.selling_plans : [];
      plans.forEach((plan) => {
        const name = String(plan?.selling_plan_name || plan?.name || "")
          .toLowerCase()
          .trim();
        const options = Array.isArray(plan?.options) ? plan.options : [];
        const planIntervalKey = this.extractIntervalKey(name);
        const optionValueMatch = options.some((opt) => {
          const optionValue = String(opt?.value || "")
            .toLowerCase()
            .trim();
          const optionIntervalKey = this.extractIntervalKey(optionValue);
          if (optionValue && optionValue === selectedValue) return true;
          if (
            selectedIntervalKey &&
            optionIntervalKey &&
            optionIntervalKey === selectedIntervalKey
          ) {
            return true;
          }
          return false;
        });

        const intervalMatch =
          selectedIntervalKey && planIntervalKey && planIntervalKey === selectedIntervalKey;

        if ((selectedLabel && name === selectedLabel) || optionValueMatch || intervalMatch) {
          const id = Number.parseInt(String(plan?.id || ""), 10);
          if (Number.isFinite(id)) {
            candidates.push(id);
          }
        }
      });
    });

    if (Number.isFinite(fromCard) && candidates.includes(fromCard)) {
      return fromCard;
    }
    if (candidates.length > 0) {
      return candidates[0];
    }
    return allowCardFallback && Number.isFinite(fromCard) ? fromCard : null;
  }

  updateBoxCardSubtitles() {
    const discountProduct = this.getSelectedDiscountProduct();
    const unlocked = this.isFreeGiftUnlocked();
    const subscriptionSuffix = this.getSelectedSchedulePlan() ? " when you subscribe" : "";
    const subtitle =
      unlocked && discountProduct?.title
        ? `+ Free ${discountProduct.title}${subscriptionSuffix}`
        : "";

    this.querySelectorAll(".pf-pick-row > .box-card .box-card__subtitle").forEach((subtitleEl) => {
      subtitleEl.textContent = subtitle;
      subtitleEl.toggleAttribute("hidden", !subtitle);
    });
  }

  restoreCheckoutButtons() {
    if (typeof window.syncPfBundlePrimaryCtaLabels === "function") {
      window.syncPfBundlePrimaryCtaLabels();
    } else {
      this.querySelectorAll(".pf-bundle-box__cta:not([data-pf-addon-confirm])").forEach((btn) => {
        if (!btn.querySelector(".spinner")) return;
        btn.textContent = btn.classList.contains("pf-bundle-box__cta--checkout")
          ? "CHECKOUT"
          : "MAKE SELECTIONS";
        btn.disabled = !btn.classList.contains("pf-bundle-box__cta--checkout");
      });
    }
  }

  connectedCallback() {
    this.initMobileBottomOffsetSync();
    // Experiment BM-151
    const syncMinCheckoutUi = () => {
      if (typeof window.syncPfBundlePrimaryCtaLabels === "function") {
        window.syncPfBundlePrimaryCtaLabels();
      }
      if (typeof window.updatePfBundleShippingProgress === "function") {
        window.updatePfBundleShippingProgress(this.lastBundleTotalCents || 0);
      }
    };
    if (typeof window.updatePfBundleShippingProgress === "function") {
      window.updatePfBundleShippingProgress(this.lastBundleTotalCents || 0);
    }
    this.refreshExistingCartTotalCents().then(syncMinCheckoutUi);
    this._onCartUpdateForMinCheckout = () => {
      this.refreshExistingCartTotalCents().then(syncMinCheckoutUi);
    };
    document.addEventListener(ThemeEvents.cartUpdate, this._onCartUpdateForMinCheckout);
    // End Experiment BM-151
    this.querySelectorAll(".pf-bundle-box__cta").forEach((btn) => {
      btn.addEventListener("click", () => {
        if (btn.disabled) return;
        if (!btn.classList.contains("pf-bundle-box__cta--checkout")) return;
        if (this.bundleProductData.isDynamicBundle) {
          this.submitDynamicBundle();
        } else {
          this.submitBundle();
        }
      });
    });
    document.addEventListener("pf:bundle-schedule-selected", () => {
      this.updateBoxCardSubtitles();
    });

    // Ensure bundle state refreshes when the page is shown (including bfcache/back navigation)
    const refreshBundle = () => {
      this.ensureConnectedRun(() => {
        try {
          this.resetBundle();
        } catch (err) {}
      });
    };

    let resetPending = false;

    const scheduleReset = () => {
      if (resetPending) return;
      resetPending = true;
      this.restoreCheckoutButtons();
      // Use a slightly longer timeout so Safari has finished restoring
      // DOM/form state from bfcache before we wipe inputs/DOM.
      setTimeout(() => {
        resetPending = false;
        this.ensureConnectedRun(() => {
          try {
            this.resetBundle();
            this.restoreCheckoutButtons();
          } catch (e) {}
        });
      }, 100); // 100ms gives Safari room to restore state
    };

    window.addEventListener("pageshow", (e) => {
      this.restoreCheckoutButtons();
      if (e.persisted) scheduleReset(); // only on bfcache restore, not initial load
    });

    // Only use one popstate handler (scheduleReset). Don't run refresh on ordinary reloads.
    window.addEventListener("popstate", scheduleReset);
    // Listen for visibility/focus but only trigger when navigation type is back_forward
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState !== "visible") return;
      const nav = performance.getEntriesByType("navigation")[0];
      if (nav?.type === "back_forward") {
        this.restoreCheckoutButtons();
        refreshBundle();
      }
    });
    window.addEventListener("focus", () => {
      const nav = performance.getEntriesByType("navigation")[0];
      if (nav?.type === "back_forward") {
        this.restoreCheckoutButtons();
        refreshBundle();
      }
    });
  }

  ensureConnectedRun(fn) {
    const tryRun = () => {
      if (this.isConnected && document.readyState !== "prerender") {
        try {
          fn();
        } catch (e) {}
      } else {
        requestAnimationFrame(tryRun);
      }
    };
    tryRun();
  }

  initMobileBottomOffsetSync() {
    if (window.__pfMobileBottomOffsetBound) return;
    window.__pfMobileBottomOffsetBound = true;
    let rafId = null;
    const applyOffset = () => {
      let offset = 0;
      if (window.visualViewport) {
        const vv = window.visualViewport;
        offset = Math.max(0, Math.round(window.innerHeight - (vv.height + vv.offsetTop)));
      }
      document.documentElement.style.setProperty("--pf-mobile-vv-offset", `${offset}px`);
    };
    // Schedule inside rAF so we always read post-layout values,
    // avoiding Chrome toolbar-animation intermediate states getting stuck.
    const updateOffset = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        applyOffset();
        // Extra pass after a short delay to catch the tail of Chrome's
        // toolbar hide/show animation when no further events fire.
        clearTimeout(window.__pfOffsetSettle);
        window.__pfOffsetSettle = setTimeout(applyOffset, 250);
      });
    };
    applyOffset();
    window.addEventListener("resize", updateOffset, { passive: true });
    window.addEventListener("scroll", updateOffset, { passive: true });
    window.visualViewport?.addEventListener("resize", updateOffset, {
      passive: true,
    });
    window.visualViewport?.addEventListener("scroll", updateOffset, {
      passive: true,
    });
  }

  updateSellingPlan(e = null) {
    let sellingPlan = "";
    let sellingPlanText = "";
    if (e === null) {
      const selectedCard =
        this.querySelector(".schedule-card.selected") || this.querySelector(".schedule-card");
      sellingPlan = selectedCard?.getAttribute("data-plan") || "";
      sellingPlanText = selectedCard?.getAttribute("data-text") || "";
    } else {
      sellingPlan = e.getAttribute("data-plan") || "";
      sellingPlanText = e.getAttribute("data-text") || "";
    }
    const sellingPlanInput = this.form.querySelector('[name="selling_plan"]');
    sellingPlanInput.value = sellingPlan;
    sellingPlanInput.setAttribute("data-text", sellingPlanText);
    this.sellingPlan = sellingPlan;
    this.sellingPlanText = sellingPlanText;
  }

  async rechargeLoader() {
    const getBundle = await recharge.cdn.getCDNBundleSettings(this.externalProductId);
    console.log("Loaded recharge bundle data", getBundle);

    if (!getBundle) {
      console.warn("RechargeBundle: bundle settings were not found", this.externalProductId);
      document.dispatchEvent(new CustomEvent("Recharge:Bundle:Loaded"));
      return;
    }
    // Derive collection IDs from every variant in the bundle.
    const variants = Array.isArray(getBundle.variants) ? getBundle.variants : [];
    const optionSources = variants.flatMap((variant) =>
      Array.isArray(variant.option_sources) ? variant.option_sources : []
    );
    const collectionIds = Array.from(
      new Set(optionSources.map((source) => source.collection_id).filter(Boolean))
    );

    const defaultVariant = variants.find(
      (e) => String(e.external_variant_id) === String(getBundle.default_bundle_variant_id)
    );
    if (!defaultVariant) {
      console.warn(
        "RechargeBundle: default variant not found",
        getBundle.default_bundle_variant_id,
        getBundle.variants
      );
    }

    const primaryVariant = defaultVariant || variants[0] || null;
    const primaryRange =
      (Array.isArray(primaryVariant?.ranges) && primaryVariant.ranges[0]) || null;
    this.priceRule = String(getBundle.price_rule || "fixed").toLowerCase();
    this.quantityMin =
      primaryRange && Number.isFinite(parseInt(primaryRange.quantity_min, 10))
        ? parseInt(primaryRange.quantity_min, 10)
        : null;
    this.quantityMax =
      primaryRange && Number.isFinite(parseInt(primaryRange.quantity_max, 10))
        ? parseInt(primaryRange.quantity_max, 10)
        : null;
    this.isDynamicBundle =
      this.priceRule === "dynamic" ||
      (variants.length === 1 &&
        parseInt(primaryVariant?.items_count, 10) === 0 &&
        this.quantityMax != null);

    this.bundleProductData = {
      variantId: getBundle.default_bundle_variant_id || primaryVariant?.external_variant_id || null,
      productId: getBundle.external_product_id,
      handle: this.getAttribute("shopify-product-handle"),
      variants,
      collectionIds,
      priceRule: this.priceRule,
      quantityMin: this.quantityMin,
      quantityMax: this.quantityMax,
      isDynamicBundle: this.isDynamicBundle,
    };
    console.log(this.bundleProductData, "bundle product data");
    if (typeof getBundle.max_quantity_per_variant !== "undefined") {
      this.maxPerProduct = getBundle.max_quantity_per_variant;
    }

    if (typeof getBundle.layout_settings?.crossSells !== "undefined") {
      if (getBundle.layout_settings.crossSells.collectionHandle !== "") {
        this.crossSellCollection = getBundle.layout_settings.crossSells.collectionHandle;
      }
    }
    if (typeof getBundle.layout_settings?.addons !== "undefined") {
      if (getBundle.layout_settings.addons.collectionHandle !== "") {
        this.addonsCollection = getBundle.layout_settings.addons.collectionHandle;
      }
    }

    this.boxes = variants.map((e) => {
      return {
        items_count: e.items_count,
        id: e.external_variant_id,
      };
    });

    this.applyBundleModeToDom();

    const collectionHandleRes = await fetch(`/collections.json`);
    const collectionHandleJson = await collectionHandleRes.json();
    const collectionHandleData = Array.from(collectionHandleJson.collections)
      .filter((e) => this.bundleProductData.collectionIds.find((g) => parseInt(g) === e.id))
      .map((e) => ({ id: e.id, handle: e.handle }));
    window.bundle = {
      variants,
      discount_code: this.discountCode,
      discount_product: this.discountProduct,
      priceRule: this.priceRule,
      quantityMin: this.quantityMin,
      quantityMax: this.quantityMax,
      isDynamicBundle: this.isDynamicBundle,
    };
    await this.getCollectionProducts(collectionHandleData);
    await this.loadMaxQuantity();
    await this.updateBundleTotal();
    if (this.isDynamicBundle) {
      this.applyDynamicSlotCapacity();
    } else {
      await this.loadBoxes();
    }
    this.loadFreeProduct();
    await this.initAddonPopup();
    document.dispatchEvent(new CustomEvent("Recharge:Bundle:Loaded"));
  }

  applyBundleModeToDom() {
    const root = this.querySelector("[data-pf-bundle-root]") || this;
    root.setAttribute("data-pf-price-rule", this.priceRule || "fixed");
    root.toggleAttribute("data-pf-dynamic-bundle", !!this.isDynamicBundle);
    if (this.quantityMin != null) {
      root.setAttribute("data-pf-qty-min", String(this.quantityMin));
    } else {
      root.removeAttribute("data-pf-qty-min");
    }
    if (this.quantityMax != null) {
      root.setAttribute("data-pf-qty-max", String(this.quantityMax));
    } else {
      root.removeAttribute("data-pf-qty-max");
    }
  }

  applyDynamicSlotCapacity() {
    const max = this.quantityMax != null && this.quantityMax > 0 ? this.quantityMax : 50;
    const min = this.quantityMin != null && this.quantityMin > 0 ? this.quantityMin : 1;
    if (typeof window.applyPfBundleSlotCapacity === "function") {
      window.applyPfBundleSlotCapacity(max, {
        source: "api",
        boxId: "dynamic",
        price: null,
        flexible: true,
        minQty: min,
      });
    }
    if (typeof window.syncPfBundleFlexibleMode === "function") {
      window.syncPfBundleFlexibleMode();
    }
  }

  async getCollectionProducts(collections) {
    if (!collections || collections.length === 0) {
      this.bundleProducts = [];
      return;
    }

    // Fetch all collections in parallel
    const productPromises = collections.map(async ({ id, handle }) => {
      const res = await fetch(`/collections/${handle}/products.json`);
      const data = await res.json();
      // ← This is the important change
      const enhancedProducts = await Promise.all(
        (data.products || []).map(async (e) => {
          const rechargeSubscription = await recharge.cdn.getCDNProduct(e.id);
          const productRes = await fetch(`/products/${e.handle}.js`);
          const productData = await productRes.json();
          return {
            ...e,
            tags: productData.tags ?? e.tags,
            selling_plan_groups: productData.selling_plan_groups,
            collectionId: id,
          };
        })
      );
      return enhancedProducts; // ← now fully enriched
    });
    // Wait for ALL fetches to finish
    const allProductArrays = await Promise.all(productPromises);

    // Flatten into one array
    this.bundleProducts = allProductArrays.flat();
    window.bundle.bundleItems = this.bundleProducts;
    this.loadProducts();
  }

  duplicateProductCard(
    productId,
    productTitle,
    imageBaseUrl,
    productDescription = "",
    productPriceCents = null
  ) {
    // 1. Grab the first product card on the page (fallback to document)
    let original = this.querySelector(".product-card") || document.querySelector(".product-card");
    if (!original) {
      console.error("No .product-card found in component or document!");
      return null;
    }

    // 2. Clone it
    const card = original.cloneNode(true);

    // 3. Change the IDs and data attributes
    card.setAttribute("data-pf-product-id", productId);
    card.setAttribute("data-pf-product-title", productTitle);
    card.setAttribute("data-pf-title", productTitle);
    if (productPriceCents != null && Number.isFinite(productPriceCents)) {
      card.setAttribute("data-pf-product-price", String(productPriceCents));
    }
    const productData = this.bundleProducts?.find((p) => String(p.id) === String(productId));
    const sellingPlanGroupId = productData?.selling_plan_groups?.[0]?.id;
    if (sellingPlanGroupId != null) {
      card.setAttribute("data-selling-plan-group", String(sellingPlanGroupId));
    }

    // 4. Update the image URLs
    card.setAttribute("data-pf-product-image", `${imageBaseUrl}&width=240`);
    card.setAttribute("data-pf-gallery", `${imageBaseUrl}&width=1600`);

    // 5. Change the visible title
    const titleEl = card.querySelector(".product-title");
    if (titleEl) titleEl.textContent = productTitle;
    const descEl = card.querySelector(".product-description");
    if (descEl) descEl.innerHTML = productDescription || "";
    const modalDesc = card.querySelector("template.pf-product-modal-desc");
    if (modalDesc) modalDesc.innerHTML = productDescription || "";
    this.applyTagBadgesToCard(card, productData?.tags);

    // 6. Change the image (src + srcset + alt)
    const img = card.querySelector("img.product-image");
    if (img) {
      img.alt = productTitle;
      img.src = `${imageBaseUrl}?width=800`;
      img.srcset = `
      ${imageBaseUrl}&width=200 200w,
      ${imageBaseUrl}&width=400 400w,
      ${imageBaseUrl}&width=600 600w,
      ${imageBaseUrl}&width=800 800w
    `.trim();
    }

    // 7. Fix the quantity input name (important for cart)
    const qtyInput = card.querySelector("input.quantity-input");
    if (qtyInput) {
      qtyInput.name = `quantity[${productId}]`;
      qtyInput.setAttribute("product-id", productId);
      qtyInput.setAttribute("data-product-id", productId);
      qtyInput.setAttribute("data-pf-product-id", productId);
      qtyInput.value = 0;
      qtyInput.setAttribute("data-pf-prev-qty", "0");
    }

    return card;
  }

  loadProducts() {
    this.bundleProducts.forEach((p) => {
      try {
        const exists = this.querySelector(`.product-card[data-pf-product-id="${p.id}"]`);
        if (p.variants.length === 1) {
          const variantOption = p.variants[0].option1;
          console.log(variantOption);
          if (variantOption && variantOption.toLowerCase() !== "default title") {
            exists
              .querySelector(".product-description")
              .insertAdjacentHTML(
                "beforebegin",
                `<div class="product-variant">${variantOption}</div>`
              );
          }
        }
        if (exists) {
          this.applyTagBadgesToCard(exists, p.tags);
          return;
        }

        if (!this.productGrid) {
          console.error("No .product-grid available to render bundle products");
          return;
        }

        const imageSrc =
          (p.images && p.images[0] && p.images[0].src) ||
          (p.featured_image && p.featured_image.src) ||
          "";
        const availableVariant =
          (p.variants || []).find((v) => this.isVariantAvailable(v)) || p.variants?.[0];
        const rawPrice = availableVariant?.price;
        let priceCents = null;
        if (rawPrice != null && rawPrice !== "") {
          const asNumber = Number.parseFloat(rawPrice);
          if (Number.isFinite(asNumber)) {
            // Shopify products.json uses decimal dollars ("20.00").
            priceCents = String(rawPrice).includes(".")
              ? Math.round(asNumber * 100)
              : Math.round(asNumber);
          }
        }

        const newCard = this.duplicateProductCard(
          p.id,
          p.title,
          imageSrc,
          p.description || p.body_html || "",
          priceCents
        );
        if (p.variants.length === 1) {
          const variantOption = p.variants[0].option1;
          if (variantOption && variantOption.toLowerCase() !== "default title") {
            newCard
              .querySelector(".product-description")
              .insertAdjacentHTML(
                "afterend",
                `<div class="product-variant">${variantOption}</div>`
              );
          }
        }
        if (newCard) this.productGrid.insertAdjacentElement("beforeend", newCard);
      } catch (e) {
        console.error("Error adding bundle product", e);
      }
    });
    this.querySelectorAll(".quantity-input").forEach((e) => {
      e.addEventListener("change", () => this.updateBundleTotal());
    });
    this.syncBundleCardSoldOutState();
  }

  isVariantAvailable(variant) {
    const raw = variant?.available;
    if (typeof raw === "string") {
      return raw.toLowerCase() === "true";
    }
    return raw === true;
  }

  getProductBadgesFromTags(tags) {
    if (!Array.isArray(tags)) return [];
    const badges = [];
    tags.forEach((tag) => {
      const tagStripped = String(tag || "").trim();
      const tagDown = tagStripped.toLowerCase();
      if (tagDown.length < 6 || tagDown.slice(0, 6) !== "badge_") return;

      const badgeLabel = tagStripped.slice(6).replace(/_/g, " ").trim();
      if (!badgeLabel) return;

      const badgeKey = badgeLabel.toLowerCase().replace(/ /g, "_");
      const modifier =
        badgeKey === "limited_release" || badgeKey === "limited" ? "limited-release" : "";

      badges.push({
        label: badgeLabel.toUpperCase(),
        modifier,
      });
    });
    return badges;
  }

  normalizeProductTags(tags) {
    if (Array.isArray(tags)) {
      return tags.map((tag) => String(tag || "").trim()).filter(Boolean);
    }
    if (typeof tags === "string") {
      return tags
        .split(",")
        .map((tag) => tag.trim())
        .filter(Boolean);
    }
    return [];
  }

  applyTagBadgesToCard(card, tags) {
    if (!card) return;

    const normalizedTags = this.normalizeProductTags(tags);
    const badges = this.getProductBadgesFromTags(normalizedTags);
    const badgesHtml = badges
      .map((badge) => {
        const cls = badge.modifier
          ? `collection-tabs-card__badge collection-tabs-card__badge--${badge.modifier}`
          : "collection-tabs-card__badge";
        return `<span class="${cls}">${badge.label}</span>`;
      })
      .join("");

    const productInfo = card.querySelector(".product-info");
    const titleNode = card.querySelector(".product-title");
    productInfo?.querySelector(".collection-tabs-card__badges")?.remove();
    if (productInfo && titleNode && badgesHtml) {
      const badgesWrap = document.createElement("div");
      badgesWrap.className = "collection-tabs-card__badges";
      badgesWrap.innerHTML = badgesHtml;
      productInfo.insertBefore(badgesWrap, titleNode);
    }

    const modalBadge = card.querySelector("template.pf-product-modal-badge");
    if (modalBadge) {
      modalBadge.innerHTML = badgesHtml
        ? `<div class="collection-tabs-card__badges">${badgesHtml}</div>`
        : "";
    }

    card.setAttribute("data-pf-badge-count", String(badges.length));
    card.setAttribute("data-pf-badge-tags", normalizedTags.join(","));
  }

  setCardSoldOutState(card, isSoldOut) {
    if (!card) return;
    const addBtn = card.querySelector(".quantity-add-btn");
    const stepper = card.querySelector(".quantity-stepper");
    const input = card.querySelector(".quantity-input");
    const quantityControl = card.querySelector(".quantity-control");

    card.classList.toggle("is-sold-out", isSoldOut);

    if (addBtn) {
      addBtn.textContent = isSoldOut ? "SOLD OUT" : "ADD";
      addBtn.disabled = isSoldOut;
      addBtn.setAttribute("aria-disabled", isSoldOut ? "true" : "false");
      addBtn.removeAttribute("hidden");
      addBtn.style.display = "";
    }

    if (input) {
      input.disabled = isSoldOut;
      if (isSoldOut) {
        input.value = "0";
        input.dataset.pfPrevQty = "0";
      }
    }

    if (quantityControl && isSoldOut) {
      quantityControl.classList.add("is-zero");
    }

    if (stepper) {
      if (isSoldOut) {
        stepper.setAttribute("hidden", "");
        stepper.style.display = "none";
      } else {
        stepper.removeAttribute("hidden");
        stepper.style.display = "";
      }
    }
  }

  syncBundleCardSoldOutState() {
    const cards = this.querySelectorAll(".bundle-card .product-card:not(.pf-addon-product-card)");
    cards.forEach((card) => {
      const productId = Number.parseInt(card.getAttribute("data-pf-product-id") || "", 10);
      if (!Number.isFinite(productId)) return;
      const product = this.bundleProducts.find((p) => Number.parseInt(p.id, 10) === productId);
      const hasAvailableVariant = !!product?.variants?.some((variant) =>
        this.isVariantAvailable(variant)
      );
      this.setCardSoldOutState(card, !hasAvailableVariant);
    });
  }

  loadMaxQuantity() {
    if (this.maxPerProduct != null) {
      this.querySelectorAll(".quantity-input").forEach((e) => {
        e.setAttribute("max", parseInt(this.maxPerProduct));
      });
    }
    window.bundle.maxQuantity = this.maxPerProduct;
  }

  loadFreeProduct() {
    const discountProduct = this.getSelectedDiscountProduct();
    const freeProductElements = this.querySelectorAll('[data-pf-bundle-line="free"]');
    freeProductElements.forEach((freeProductElement) => {
      const hasFreeProduct = this.shouldIncludeFreeGift();
      freeProductElement.toggleAttribute("hidden", !hasFreeProduct);
      if (!hasFreeProduct) return;

      const freeName = discountProduct.title || "Free Bundle Gift";
      const freeImage = discountProduct.image || "";
      const nameEl = freeProductElement.querySelector(".pf-bundle-box__name");
      const imageEl = freeProductElement.querySelector(".pf-bundle-box__thumb-wrap img");
      const placeholderEl = freeProductElement.querySelector(".pf-bundle-box__thumb--ph");

      if (nameEl) {
        nameEl.setAttribute("data-title", freeName);
        nameEl.textContent = freeName;
      }
      if (imageEl && freeImage) {
        imageEl.src = freeImage;
        imageEl.alt = freeName;
        imageEl.removeAttribute("hidden");
        placeholderEl?.setAttribute("hidden", "");
      } else {
        imageEl?.setAttribute("hidden", "");
        placeholderEl?.removeAttribute("hidden");
      }
    });
  }

  async loadBoxes() {
    if (this.isDynamicBundle) {
      this.applyDynamicSlotCapacity();
      this.updateBoxCardSubtitles();
      return;
    }
    const boxCards = document.querySelectorAll(".pf-pick-row>.box-card");
    const boxProduct = await recharge.cdn.getCDNProduct(parseInt(this.externalProductId));
    const variantImages = JSON.parse(
      this.querySelector("#variant-images").textContent.trim().replace(/\s+/g, " ")
    );

    this.boxes.forEach((box, index) => {
      const variantMatch = boxProduct.variants.find((v) => v.id === parseInt(box.id));
      const boxPrice = variantMatch?.prices?.unit_price;
      const imageMatch = variantImages.variant_images.find(
        (e) => parseInt(e.id) === parseInt(box.id)
      );
      const boxImage = imageMatch?.image;

      if (boxCards[index]) {
        const titleEl = boxCards[index].querySelector(".box-card__title");
        const priceEl = boxCards[index].querySelector(".box-card__price");
        const hasCount = Number.isFinite(parseInt(box.items_count, 10));
        const hasPrice = Number.isFinite(parseInt(boxPrice, 10));

        if (hasCount) {
          boxCards[index].setAttribute("data-value", box.items_count);
          if (titleEl) {
            titleEl.textContent = `Box of ${box.items_count}`;
          }
          boxCards[index].setAttribute("data-pf-box-id", `bittmans-box-${box.items_count}`);
        }
        if (hasPrice) {
          boxCards[index].setAttribute("data-price", boxPrice);
          if (priceEl) {
            priceEl.textContent = this.formatMoney(boxPrice);
          }
        }
        if (boxImage) {
          const imageEl = boxCards[index].querySelector(".box-card__media img");
          if (imageEl) {
            imageEl.src = boxImage;
          }
        }
      } else {
        const template = this.querySelector("template-box-card .box-card"); // fix selector
        if (!template) return; // safety

        const boxCardTemplate = template.cloneNode(true);
        const hasCount = Number.isFinite(parseInt(box.items_count, 10));
        const hasPrice = Number.isFinite(parseInt(boxPrice, 10));
        const templateTitle = boxCardTemplate.querySelector(".box-card__title");
        const templatePrice = boxCardTemplate.querySelector(".box-card__price");
        const templateSubtitle = boxCardTemplate.querySelector(".box-card__subtitle");

        if (hasCount) {
          boxCardTemplate.setAttribute("data-value", box.items_count);
          if (templateTitle) {
            templateTitle.textContent = `Box of ${box.items_count}`;
          }
          boxCardTemplate.setAttribute("data-pf-box-id", `bittmans-box-${box.items_count}`);
        }
        if (hasPrice) {
          boxCardTemplate.setAttribute("data-price", boxPrice);
          if (templatePrice) {
            templatePrice.textContent = this.formatMoney(boxPrice);
          }
        }
        if (templateSubtitle) {
          templateSubtitle.textContent = "";
          templateSubtitle.setAttribute("hidden", "");
        }
        if (boxImage) {
          const templateImage = boxCardTemplate.querySelector(".box-card__media img");
          if (templateImage) {
            templateImage.src = boxImage;
          }
        }

        document
          .querySelector(".pf-pick-row:has(template-box-card)")
          .insertAdjacentElement("beforeend", boxCardTemplate);
      }
    });
    document.querySelectorAll(".box-card").forEach((e) => {
      e.addEventListener("click", () => this.updateBundleTotal());
    });
    this.updateBoxCardSubtitles();
  }

  mapAddonSourceProducts(products) {
    return (products || [])
      .map((p) => {
        const variants = p.variants || [];
        const hasAvailableVariant = variants.some((v) => this.isVariantAvailable(v));
        const variant = variants.find((v) => this.isVariantAvailable(v)) || variants[0] || null;
        if (!variant) return null;
        const imageSrc =
          (p.featured_image && p.featured_image.src) ||
          (Array.isArray(p.images) && p.images[0] && p.images[0].src) ||
          "";
        const rawPrice = variant.price;
        const price = Number.parseFloat(rawPrice);
        return {
          productId: parseInt(p.id, 10),
          variantId: parseInt(variant.id, 10),
          title: p.title,
          price: Number.isFinite(price) ? price : 0,
          imageUrl: imageSrc,
          description: p.description || p.body_html || "",
          available: hasAvailableVariant,
          tags: this.normalizeProductTags(p.tags),
        };
      })
      .filter(Boolean);
  }

  async fetchAddonProductsFromSource() {
    // Default source: same pool as CHOOSE YOUR VARIETY.
    // Replace this method later to pull from a custom JS source.
    let addOnProducts = [];
    if (this.crossSellCollection) {
      const res = await fetch(`/collections/${this.crossSellCollection}/products.json`);
      const data = await res.json();
      // ← This is the important change
      const enhancedProducts = await Promise.all(
        (data.products || []).map(async (e) => {
          const rechargeSubscription = await recharge.cdn.getCDNProduct(e.id);
          let productJson = null;
          try {
            const productRes = await fetch(`/products/${e.handle}.js`);
            if (productRes.ok) {
              productJson = await productRes.json();
            }
          } catch (err) {}
          return {
            ...e,
            tags: productJson?.tags ?? e.tags,
            selling_plan_groups: rechargeSubscription.selling_plan_groups,
          };
        })
      );
      // Flatten into one array
      addOnProducts = enhancedProducts;
    }
    if (this.addonsCollection) {
      const addonsRes = await fetch(`/collections/${this.addonsCollection}/products.json`);
      const addonsData = await addonsRes.json();
      const addonsProducts = await Promise.all(
        (addonsData.products || []).map(async (e) => {
          const rechargeSubscription = await recharge.cdn.getCDNProduct(e.id);
          let productJson = null;
          try {
            const productRes = await fetch(`/products/${e.handle}.js`);
            if (productRes.ok) {
              productJson = await productRes.json();
            }
          } catch (err) {}
          return {
            ...e,
            tags: productJson?.tags ?? e.tags,
            selling_plan_groups: rechargeSubscription.selling_plan_groups,
          };
        })
      );

      addOnProducts = [...addOnProducts, ...addonsProducts];
    }

    return addOnProducts || [];
  }

  async buildAddonCatalog() {
    const sourceProducts = await this.fetchAddonProductsFromSource();
    return this.mapAddonSourceProducts(sourceProducts);
  }

  async initAddonPopup() {
    this.addonSection = this.querySelector('[data-pf-bundle-section="addons"]');
    this.addonGrid = this.querySelector("[data-pf-addon-grid]");
    this.addonModal = null;
    this.addonPrevBtn = null;
    this.addonNextBtn = null;
    if (!this.addonGrid) return;
    this.addonCatalog = await this.buildAddonCatalog();
    if (this.addonCatalog.length === 0) {
      this.addonSection?.setAttribute("hidden", "");
      return;
    }
    this.addonSection?.removeAttribute("hidden");
    this.renderAddonCards();
    this.renderAddonSummary();
  }

  resetBundle() {
    // Clear addon selections and totals so the UI resets to empty state
    try {
      this.addonSelections.clear();
    } catch (e) {
      this.addonSelections = new Map();
    }
    this.addonTotal = 0;

    // Reset any addon quantity inputs inside this component
    this.querySelectorAll(
      ".pf-addon-product-card .quantity-input, .pf-bundle-box__body .quantity-input, .bundle-card .product-card .quantity-input"
    ).forEach((input) => {
      try {
        input.value = "0";
        input.dataset.pfPrevQty = "0";
      } catch (e) {}
      const control = input.closest(".quantity-control");
      if (control) {
        control.classList.add("is-zero");
      }
      const card = input.closest(".product-card");
      if (card) card.classList.remove("active");
    });

    // Remove any addon summary list items added previously
    this.querySelectorAll(".pf-bundle-box__item--addon-line").forEach((el) => el.remove());

    // Also clear global bundle slot state (filled product lines)
    try {
      if (typeof window.applyPfBundleSlotCapacity === "function") {
        // Read current capacity from DOM (set by syncPfBundleListCapacityAttr)
        const listEl = document.querySelector("[data-pf-bundle-list]");
        const currentCap = listEl
          ? parseInt(listEl.getAttribute("data-pf-bundle-capacity"), 10) || 0
          : 0;

        // Temporarily set capacity to 0 to clear the internal slot order,
        // then restore the original capacity on the next tick so we don't
        // leave `body.pf-bundle-needs-box` active (which disables add buttons).
        try {
          window.applyPfBundleSlotCapacity(0, { source: "api" });
        } catch (e) {}

        setTimeout(() => {
          try {
            if (this.isDynamicBundle) {
              this.applyDynamicSlotCapacity();
            } else {
              window.applyPfBundleSlotCapacity(currentCap, { source: "api" });
            }
          } catch (e) {}
          if (typeof window.renderPfBundleBoxLists === "function") {
            window.renderPfBundleBoxLists();
          }
          if (window.updatePfBundleListScrollHints) window.updatePfBundleListScrollHints();
          if (window.syncPfBundlePrimaryCtaLabels) window.syncPfBundlePrimaryCtaLabels();
          if (typeof window.refreshPfBundlePricing === "function") {
            window.refreshPfBundlePricing();
          }
        }, 0);
      } else {
        if (typeof window.renderPfBundleBoxLists === "function") {
          window.renderPfBundleBoxLists();
        }
        if (window.updatePfBundleListScrollHints) window.updatePfBundleListScrollHints();
        if (window.syncPfBundlePrimaryCtaLabels) window.syncPfBundlePrimaryCtaLabels();
      }
    } catch (e) {}

    // Re-render UI and recalc totals
    this.renderAddonCards();
    this.renderAddonSummary();
    try {
      this.setTotals();
    } catch (e) {}
  }

  renderAddonCards() {
    if (!this.addonGrid) return;
    this.addonGrid.innerHTML = "";
    let sourceCards = this.querySelectorAll(
      ".bundle-card .product-card:not(.pf-addon-product-card)"
    );
    if (!sourceCards || sourceCards.length === 0) {
      sourceCards = document.querySelectorAll(
        ".bundle-card .product-card:not(.pf-addon-product-card)"
      );
    }
    this.addonCatalog.forEach((item) => {
      const sourceCard = sourceCards[0];
      if (!sourceCard) return;
      const card = sourceCard.cloneNode(true);
      card.classList.add("pf-addon-product-card");
      card.setAttribute("data-addon-product-id", String(item.productId));
      card.setAttribute("data-pf-product-id", String(item.productId));
      card.setAttribute("data-pf-product-image", String(item.imageUrl || ""));
      card.setAttribute("data-pf-gallery", String(item.imageUrl || ""));
      card.setAttribute("data-pf-title", String(item.title));
      card.setAttribute("data-pf-product-title", String(item.title));
      if (item.price != null) {
        card.setAttribute("data-pf-product-price", String(Math.round(Number(item.price) * 100)));
      }

      card.querySelector(".product-card__badge")?.remove();
      const oneTimeBadgeWrap = document.createElement("div");
      oneTimeBadgeWrap.className = "product-card__badge";
      oneTimeBadgeWrap.innerHTML =
        '<span class="pf-badge pf-badge--addon-onetime">ONE-TIME PURCHASE</span>';
      card.insertBefore(oneTimeBadgeWrap, card.firstChild);
      const modalBadge = card.querySelector("template.pf-product-modal-badge");

      const titleEl = card.querySelector(".product-title");
      if (titleEl) {
        titleEl.textContent = String(item.title);
        const existingPrice = card.querySelector(".product-price");
        if (existingPrice) existingPrice.remove();
        titleEl.insertAdjacentHTML(
          "afterend",
          `<div class="product-price">$${Number(item.price || 0).toFixed(2)}</div>`
        );
      }
      const mediaImg = card.querySelector(".product-card__media img");
      if (mediaImg && item.imageUrl) {
        mediaImg.src = String(item.imageUrl);
        mediaImg.alt = String(item.title || "");
        mediaImg.removeAttribute("srcset");
      }
      const descEl = card.querySelector(".product-description");
      if (descEl) {
        const plain = String(item.description || "")
          .replace(/<[^>]*>/g, " ")
          .replace(/\s+/g, " ")
          .trim();
        descEl.textContent = plain;
      }
      const modalDesc = card.querySelector("template.pf-product-modal-desc");
      if (modalDesc) modalDesc.innerHTML = String(item.description || "");

      const productInfo = card.querySelector(".product-info");
      const titleNode = card.querySelector(".product-title");
      productInfo?.querySelector(".collection-tabs-card__badges")?.remove();
      const badges = this.getProductBadgesFromTags(item.tags);
      card.setAttribute(
        "data-pf-badge-tags",
        Array.isArray(item.tags) ? item.tags.join(",") : String(item.tags || "")
      );
      card.setAttribute("data-pf-badge-count", String(badges.length));

      const badgesHtml = badges
        .map((badge) => {
          const cls = badge.modifier
            ? `collection-tabs-card__badge collection-tabs-card__badge--${badge.modifier}`
            : "collection-tabs-card__badge";
          return `<span class="${cls}">${badge.label}</span>`;
        })
        .join("");

      if (modalBadge) {
        modalBadge.innerHTML = badgesHtml
          ? `<div class="collection-tabs-card__badges">${badgesHtml}</div>`
          : "";
      }

      if (productInfo && titleNode && badges.length > 0) {
        const badgesWrap = document.createElement("div");
        badgesWrap.className = "collection-tabs-card__badges";

        badgesWrap.innerHTML = badgesHtml;

        productInfo.insertBefore(badgesWrap, titleNode);
      }

      const qty = this.addonSelections.get(item.productId)?.quantity || 0;
      const isSoldOut = !item.available;
      const input = card.querySelector(".quantity-input");
      const quantityControl = card.querySelector(".quantity-control");
      const addBtn = card.querySelector(".quantity-add-btn");
      const stepper = card.querySelector(".quantity-stepper");
      const decBtn = card.querySelector(".quantity-decrease");
      const incBtn = card.querySelector(".quantity-increase");
      if (input) {
        input.value = String(isSoldOut ? 0 : qty);
        input.setAttribute("min", "0");
        input.dataset.pfPrevQty = String(isSoldOut ? 0 : qty);
        input.removeAttribute("product-id");
        input.removeAttribute("data-product-id");
        input.removeAttribute("data-pf-product-id");
        input.name = `addon_quantity[${item.productId}]`;
        input.disabled = isSoldOut;
      }
      if (quantityControl) {
        quantityControl.classList.toggle("is-zero", isSoldOut || qty <= 0);
      }
      card.classList.toggle("active", !isSoldOut && qty > 0);
      if (addBtn) {
        addBtn.removeAttribute("hidden");
        addBtn.style.display = "";
      }
      if (stepper) {
        if (isSoldOut) {
          stepper.setAttribute("hidden", "");
          stepper.style.display = "none";
        } else {
          stepper.removeAttribute("hidden");
          stepper.style.display = "";
        }
      }
      if (isSoldOut) {
        this.addonSelections.delete(item.productId);
      }
      this.setCardSoldOutState(card, isSoldOut);
      if (!isSoldOut) {
        addBtn?.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.setAddonQty(item.productId, 1);
        });
        decBtn?.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.setAddonQty(item.productId, qty - 1);
        });
        incBtn?.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.setAddonQty(item.productId, qty + 1);
        });
        input?.addEventListener("change", (e) => {
          const v = parseInt(e.target.value, 10) || 0;
          this.setAddonQty(item.productId, v);
        });
      }
      this.addonGrid.appendChild(card);
    });
  }

  openAddonModal() {
    // Add-ons are inline; keep method for compatibility.
  }

  closeAddonModal() {
    // Add-ons are inline; keep method for compatibility.
  }

  setAddonQty(productId, nextQty) {
    const qty = Math.max(0, parseInt(nextQty, 10) || 0);
    const catalogItem = this.addonCatalog.find((i) => i.productId === productId);
    if (!catalogItem) return;
    if (qty <= 0) {
      this.addonSelections.delete(productId);
    } else {
      this.addonSelections.set(productId, {
        ...catalogItem,
        quantity: qty,
      });
    }
    this.setTotals();
    this.renderAddonCards();
    this.renderAddonSummary();
  }

  setTotals() {
    const getBasePriceDollars = () => {
      if (typeof window.getPfBundleBasePriceDollars === "function") {
        const fromUi = window.getPfBundleBasePriceDollars();
        if (Number.isFinite(fromUi)) return fromUi;
      }
      const selectedBox = this.querySelector(".box-card.selected");
      return parseFloat(selectedBox?.getAttribute("data-price") || "0") || 0;
    };
    const getDiscountRaw = () => {
      const selectedSchedule = this.querySelector(".schedule-card.selected");
      return String(selectedSchedule?.getAttribute("data-discount") || "0");
    };
    const applyDiscount = (priceDollars, discountRaw) => {
      const discountValue = parseFloat(String(discountRaw).replace("%", "")) || 0;
      if (String(discountRaw).includes("%")) {
        return priceDollars * ((100 - discountValue) / 100);
      }
      return Math.max(0, priceDollars - discountValue);
    };

    const basePrice = getBasePriceDollars();
    const discount = getDiscountRaw();
    const discounted = applyDiscount(basePrice, discount);
    let addonExtra = 0;
    Array.from(this.addonSelections.values()).forEach((selection) => {
      addonExtra += (parseFloat(selection.price) || 0) * (parseInt(selection.quantity, 10) || 0);
    });

    this.lastBundleTotalCents = Math.round((discounted + addonExtra) * 100);

    if (typeof window.setPfBundleMirrorNodes === "function") {
      window.setPfBundleMirrorNodes("price-schedule", `$${(discounted + addonExtra).toFixed(2)}`);
      if (discounted < basePrice) {
        window.setPfBundleMirrorNodes("price-today", `$${(basePrice + addonExtra).toFixed(2)}`);
      } else {
        window.setPfBundleMirrorNodes("price-today", "");
      }
    }
    if (typeof window.updatePfBundleShippingProgress === "function") {
      window.updatePfBundleShippingProgress(this.lastBundleTotalCents);
    }
    this.loadFreeProduct();
    this.updateBoxCardSubtitles();
    if (typeof window.renderPfBundleBoxLists === "function") {
      window.renderPfBundleBoxLists();
    }
    // Experiment BM-151
    if (typeof window.syncPfBundlePrimaryCtaLabels === "function") {
      window.syncPfBundlePrimaryCtaLabels();
    }
    // End Experiment BM-151
  }

  renderAddonSummary() {
    const entries = Array.from(this.addonSelections.values()).filter((i) => i.quantity > 0);
    let sections = Array.from(this.querySelectorAll("[data-pf-addon-summary-section]"));
    if (sections.length === 0) {
      sections = Array.from(document.querySelectorAll("[data-pf-addon-summary-section]"));
    }
    sections.forEach((section) => {
      section.toggleAttribute("hidden", entries.length === 0);
    });

    // Render into lists; fall back to document if component has none (timing/bfcache differences)
    let lists = Array.from(this.querySelectorAll("[data-pf-addon-summary-list]"));
    if (lists.length === 0) {
      lists = Array.from(document.querySelectorAll("[data-pf-addon-summary-list]"));
    }
    if (lists.length === 0) {
      console.warn("renderAddonSummary: no [data-pf-addon-summary-list] targets found");
      return;
    }

    lists.forEach((list) => {
      list.innerHTML = "";
      list.toggleAttribute("hidden", entries.length === 0);
      entries.forEach((item) => {
        const li = document.createElement("li");
        li.className = "pf-bundle-box__item pf-bundle-box__item--addon-line";
        const thumb = String(item.imageUrl || "").trim();
        li.innerHTML = `<span class="pf-bundle-box__idx" aria-hidden="true"></span><div class="pf-bundle-box__thumb-wrap"><img class="pf-bundle-box__thumb-img" alt="${String(
          item.title || ""
        )}" width="80" height="80" loading="lazy" decoding="async" ${thumb ? `src="${thumb}"` : ""} ${thumb ? "" : "hidden"}><span class="pf-bundle-box__thumb pf-bundle-box__thumb--ph" aria-hidden="true" ${thumb ? "hidden" : ""}></span></div><div class="pf-bundle-box__meta"><span class="pf-bundle-box__name" data-title="${String(
          item.title || "Free Bundle Gift"
        )}">${String(item.title || "")} $${item.price.toFixed(2)}</span><button type="button" class="pf-bundle-box__remove" data-pf-addon-remove-id="${item.productId}">Remove</button></div><span class="pf-bundle-box__qty">x${item.quantity}</span>`;
        const removeBtn = li.querySelector("[data-pf-addon-remove-id]");
        if (removeBtn) {
          removeBtn.addEventListener("click", (e) => {
            e.preventDefault();
            this.setAddonQty(item.productId, 0);
          });
        }
        list.appendChild(li);
      });
    });
  }

  getAddonCartItems() {
    return Array.from(this.addonSelections.values())
      .filter((item) => item.quantity > 0)
      .map((item) => ({
        id: item.variantId,
        quantity: item.quantity,
        properties: { _rb_addon: true, _rb_id: this.bundleId },
      }));
  }

  scrollAddonGrid(direction) {
    if (!this.addonGrid) return;
    const card = this.addonGrid.querySelector(".product-card");
    const cardWidth = card ? card.getBoundingClientRect().width : 312;
    const gap = 8;
    const delta = cardWidth + gap;
    const nextLeft =
      direction === "prev" ? this.addonGrid.scrollLeft - delta : this.addonGrid.scrollLeft + delta;
    this.addonGrid.scrollTo({ left: nextLeft, behavior: "smooth" });
  }

  syncAddonNavButtons() {
    // Inline add-ons grid has no carousel nav.
  }

  _pfCopyAttr(suffix, fallback) {
    const layout = this.querySelector("[data-pf-bundle-root]");
    const v = layout && layout.getAttribute("data-pf-copy-" + suffix);
    return v != null && String(v).trim() !== "" ? String(v).trim() : fallback;
  }

  updateBundleTotal() {
    const minMax = this.getRequiredItemCount();
    let totalItems = 0;
    let quantityInputs = this.querySelectorAll(
      ".bundle-card .product-card:not(.pf-addon-product-card) .quantity-input"
    );
    quantityInputs.forEach((input) => {
      const quantity = Number.parseInt(input.value, 10) || 0;
      const productId = parseInt(input.getAttribute("product-id"), 10);
      const item = this.bundleProducts.find((e) => parseInt(e.id, 10) === productId);
      if (!item) return; // safety: skip if item not found

      const variant = item.variants.find((v) => this.isVariantAvailable(v));
      if (!variant) return; // safety: skip if no available variant

      totalItems += quantity;
    });

    const msgItemsExact = this._pfCopyAttr(
      "msg-items-exact",
      this.isDynamicBundle
        ? "Please select at least [count] items for your box"
        : "Please select exactly [count] items for your box"
    );
    const msgItemsExactPeriod = this._pfCopyAttr(
      "msg-items-exact-period",
      this.isDynamicBundle
        ? "Please select at least [count] items for your box."
        : "Please select exactly [count] items for your box."
    );

    let addToCartButton = document.querySelector(".add-bundle-to-cart");
    let isValid = this.isValidTotalQuantity(totalItems);
    if (addToCartButton) {
      addToCartButton.disabled = !isValid;
      addToCartButton.title = isValid ? "" : msgItemsExact.replace(/\[count\]/gi, String(minMax));
    }
    let errorMessage = document.getElementById("bundle-error-message");
    if (errorMessage) {
      errorMessage.textContent = isValid
        ? ""
        : msgItemsExactPeriod.replace(/\[count\]/gi, String(minMax));
    }
  }

  getRequiredItemCount() {
    if (this.isDynamicBundle) {
      return this.quantityMin != null && this.quantityMin > 0 ? this.quantityMin : 1;
    }
    return (
      parseInt(
        document.querySelector(".recharge-selector .box-card.selected")?.getAttribute("data-value")
      ) ||
      parseInt(this.querySelector(".box-card.selected")?.getAttribute("data-value")) ||
      6
    );
  }

  getSelectedBundleVariantId() {
    const variants = this.bundleProductData?.variants || [];
    if (this.isDynamicBundle) {
      const byId = variants.find(
        (e) => String(e.external_variant_id) === String(this.bundleProductData.variantId)
      );
      return parseInt((byId || variants[0])?.external_variant_id, 10);
    }
    const minMax = this.getRequiredItemCount();
    const byCount = variants.find((e) => e.items_count === minMax);
    return parseInt((byCount || variants[0])?.external_variant_id, 10);
  }

  isValidTotalQuantity(totalItems) {
    if (this.isDynamicBundle) {
      const min = this.quantityMin != null && this.quantityMin > 0 ? this.quantityMin : 1;
      const max = this.quantityMax != null && this.quantityMax > 0 ? this.quantityMax : Infinity;
      return totalItems >= min && totalItems <= max;
    }
    const minMax = this.getRequiredItemCount();
    return (minMax === 0 || totalItems <= minMax) && (minMax === 0 || totalItems >= minMax);
  }

  formatMoney(cents) {
    let formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });
    return formatter.format(cents);
  }

  getPurchaseType() {
    const scheduleSelection = this.getSelectedScheduleSelection();
    const value = String(scheduleSelection.value || "")
      .toLowerCase()
      .trim();
    if (value === "onetime") return "one_time";

    const intervalKey =
      this.extractIntervalKey(scheduleSelection.label) || this.extractIntervalKey(value);
    if (intervalKey === "4-week") return "subscription_4_week";
    if (intervalKey === "8-week") return "subscription_8_week";
    if (value === "one_time") return "one_time";
    return "one_time";
  }

  getScheduleDiscountPercent() {
    const discountRaw = String(
      this.querySelector(".schedule-card.selected")?.getAttribute("data-discount") || "0"
    );
    if (!discountRaw.includes("%")) return 0;
    const discountValue = parseFloat(String(discountRaw).replace("%", "")) || 0;
    return Number.isFinite(discountValue) ? discountValue : 0;
  }

  getProductUnitPriceDollars(productId) {
    const card = this.querySelector(
      `.bundle-card .product-card:not(.pf-addon-product-card)[data-pf-product-id="${productId}"]`
    );
    const fromCard = Number.parseInt(card?.getAttribute("data-pf-product-price") || "", 10);
    if (Number.isFinite(fromCard)) return fromCard / 100;

    const bundleItem = this.bundleProducts?.find((p) => String(p.id) === String(productId));
    const variant =
      (bundleItem?.variants || []).find((v) => this.isVariantAvailable(v)) ||
      bundleItem?.variants?.[0];
    const rawPrice = variant?.price;
    if (rawPrice == null || rawPrice === "") return 0;
    const asNumber = Number.parseFloat(rawPrice);
    if (!Number.isFinite(asNumber)) return 0;
    return String(rawPrice).includes(".") ? asNumber : asNumber / 100;
  }

  buildBundleTrackingItems(selectionItems) {
    const discountPercent = this.getScheduleDiscountPercent();
    const multiplier = discountPercent > 0 ? (100 - discountPercent) / 100 : 1;
    return (selectionItems || [])
      .filter((item) => item && Number(item.quantity) > 0)
      .map((item) => {
        const unitPrice = this.getProductUnitPriceDollars(item.externalProductId);
        const price = Math.round(unitPrice * multiplier * 100) / 100;
        return {
          id: item.externalProductId,
          name: item.title,
          item_id: item.externalProductId,
          item_name: item.title,
          price,
          quantity: Number.parseInt(String(item.quantity), 10) || 0,
        };
      });
  }

  getBundleValueDollars() {
    const getBasePriceDollars = () => {
      if (typeof window.getPfBundleBasePriceDollars === "function") {
        const fromUi = window.getPfBundleBasePriceDollars();
        if (Number.isFinite(fromUi)) return fromUi;
      }
      const selectedBox = this.querySelector(".box-card.selected");
      return parseFloat(selectedBox?.getAttribute("data-price") || "0") || 0;
    };
    const discountRaw = String(
      this.querySelector(".schedule-card.selected")?.getAttribute("data-discount") || "0"
    );
    const basePrice = getBasePriceDollars();
    const discountValue = parseFloat(String(discountRaw).replace("%", "")) || 0;
    const discounted = String(discountRaw).includes("%")
      ? basePrice * ((100 - discountValue) / 100)
      : Math.max(0, basePrice - discountValue);
    return Math.round(discounted * 100) / 100;
  }

  pushBundleAddedToCartEvent(selectionItems) {
    const items = this.buildBundleTrackingItems(selectionItems);
    const bundleItemCount = items.reduce((sum, item) => sum + (item.quantity || 0), 0);
    const eventParams = {
      items,
      bundle_item_count: bundleItemCount,
      value: this.getBundleValueDollars(),
      currency: "USD",
      purchase_type: this.getPurchaseType(),
    };
    eventParams.bundle_value = eventParams.value;

    if (typeof window.gtag === "function") {
      window.gtag("event", "bundle_added_to_cart", eventParams);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "bundle_added_to_cart", ...eventParams });
  }
  // Experiment BM-151
  async refreshExistingCartTotalCents() {
    try {
      const res = await fetch("/cart.js");
      if (!res.ok) return this.existingCartTotalCents || 0;
      const cart = await res.json();
      const total = Number(cart?.total_price);
      this.existingCartTotalCents = Number.isFinite(total) ? total : 0;
      this.setAttribute("data-cart-total-cents", String(this.existingCartTotalCents));
    } catch (e) {
      // keep seeded value
    }
    return this.existingCartTotalCents || 0;
  }

  meetsCheckoutMinimum() {
    const minCheckoutCents = 4900;
    const combined = (this.existingCartTotalCents || 0) + this.computeBundleTotalCents();
    if (combined < minCheckoutCents) return false;
    let hasSelections = false;
    this.querySelectorAll(
      ".bundle-card .product-card:not(.pf-addon-product-card) .quantity-input"
    ).forEach((input) => {
      const quantity = Number.parseInt(input.value, 10);
      if (Number.isFinite(quantity) && quantity > 0) hasSelections = true;
    });
    return hasSelections;
  }
  // End Experiment BM-151

  async submitBundle(opts = {}) {
    // Experiment BM-151
    await this.refreshExistingCartTotalCents();
    if (!this.meetsCheckoutMinimum()) {
      this.restoreCheckoutButtons();
      return;
    }
    // End Experiment BM-151

    this.querySelectorAll(".pf-bundle-box__cta").forEach((btn) => {
      btn.innerHTML = this.spinner;
      btn.disabled = true;
    });

    const bundleItems = this.bundleProducts;
    const bundleProductData = this.bundleProductData;
    const maxPerProduct = this.maxPerProduct;
    let quantityInputs = this.querySelectorAll(
      ".bundle-card .product-card:not(.pf-addon-product-card) .quantity-input"
    );
    let items = [];
    quantityInputs.forEach((input) => {
      const quantity = Number.parseInt(input.value, 10);
      if (!Number.isFinite(quantity) || quantity <= 0) return;
      const card = input.closest(".product-card");
      const id =
        input.getAttribute("product-id") ||
        input.getAttribute("data-product-id") ||
        input.getAttribute("data-pf-product-id") ||
        card?.getAttribute("data-pf-product-id") ||
        input.getAttribute("name")?.match(/\[(\d+)\]/)?.[1] ||
        "";
      const bundleItem = bundleItems.find((e) => String(e.id) === String(id));
      if (quantity > 0) {
        if (!bundleItem) {
          console.warn("RechargeBundle: missing bundleItem for quantity input", id, input);
          return;
        }
        if (maxPerProduct != null) {
          if (quantity > maxPerProduct) {
            return;
          }
        }
        const availableVariant = bundleItem.variants.find((v) => this.isVariantAvailable(v));
        if (!availableVariant) {
          return;
        }
        items.push({
          collectionId: parseInt(bundleItem.collectionId ?? bundleProductData.collectionIds[0], 10),
          externalProductId: bundleItem.id,
          externalVariantId: availableVariant.id,
          quantity: quantity,
          title: bundleItem.title,
        });
      }
    });

    const scheduleSelection = this.getSelectedScheduleSelection();
    const dynamicItems = items.map((i) => {
      const productData = bundleItems.find((bundleItem) => {
        return bundleItem.id === i.externalProductId;
      });
      if (!productData) {
        return i;
      }
      const sellingPlanId = this.resolveSellingPlanIdForProduct(productData, scheduleSelection);
      if (sellingPlanId != null) {
        return { ...i, sellingPlan: sellingPlanId };
      }
      return i;
    });
    console.log("dynamic items", bundleItems, dynamicItems);
    const externalVariantId = this.getSelectedBundleVariantId();
    if (!Number.isFinite(externalVariantId)) {
      console.error("RechargeBundle: missing bundle variant id");
      this.restoreCheckoutButtons();
      return;
    }
    const bundle = {
      externalVariantId,
      externalProductId: parseInt(bundleProductData.productId),
      selections: [...dynamicItems],
    };
    const bundleId = await recharge.bundle.getBundleId(bundle);
    this.bundleId = bundleId;
    const selectedSellingPlan = this.resolveSellingPlanIdForProduct(
      {
        selling_plan_groups: this.bundleProductData?.variants?.[0]?.selling_plan_groups || [],
      },
      scheduleSelection,
      { allowCardFallback: true }
    );
    const fallbackSellingPlan = Number.parseInt(this.getSelectedSchedulePlan(), 10);
    const bundleCartItem = {
      id: bundle.externalVariantId,
      quantity: 1,
      properties: {
        _rb_id: bundleId,
        _pf_bundle_line_qty: "1",

        Contents: items
          .map((e) => {
            return `${e.quantity}x ${e.title}`;
          })
          .join(", "),
      },
    };
    if (Number.isFinite(selectedSellingPlan)) {
      bundleCartItem.selling_plan = selectedSellingPlan;
    } else if (Number.isFinite(fallbackSellingPlan)) {
      bundleCartItem.selling_plan = fallbackSellingPlan;
    }
    const cartData = {
      items: [bundleCartItem],
    };
    const selectedDiscountProduct = this.getSelectedDiscountProduct();
    const includeFreeGift = this.shouldIncludeFreeGift();
    if (includeFreeGift) {
      cartData.items.push({
        id: selectedDiscountProduct.variantId,
        quantity: 1,
        properties: {
          _free_butter: true,
          _rb_id: bundleId,
        },
      });
    }
    cartData.items.push(...this.getAddonCartItems());

    try {
      const addResponse = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(cartData),
      });
      if (!addResponse.ok) {
        const errBody = await addResponse.json().catch(() => ({}));
        throw new Error(`Failed to add to cart: ${JSON.stringify(errBody)}`);
      }

      if (this.discountCode && includeFreeGift) {
        await fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ discount: this.discountCode }),
        });
      }

      const newCartRes = await fetch("/cart.js");
      const newCartJson = await newCartRes.json();
      const newCartData = newCartJson.data;
      document.dispatchEvent(
        new CustomEvent(ThemeEvents.cartUpdate, {
          detail: {
            data: {
              ...newCartJson,
              sections: ["component-cart-items", "cart-drawer-component"],
            },
          },
        })
      );
      const checkoutUrl =
        this.discountCode && includeFreeGift
          ? `/checkout?discount=${encodeURIComponent(this.discountCode)}`
          : "/checkout";
      this.pushBundleAddedToCartEvent(items);
      window.location.href = checkoutUrl;
    } catch (error) {
      console.error("Error:", error);
      this.restoreCheckoutButtons();
    }
  }

  async submitDynamicBundle(opts = {}) {
    // Experiment BM-151
    await this.refreshExistingCartTotalCents();
    if (!this.meetsCheckoutMinimum()) {
      this.restoreCheckoutButtons();
      return;
    }
    // End Experiment BM-151

    this.querySelectorAll(".pf-bundle-box__cta").forEach((btn) => {
      btn.innerHTML = this.spinner;
      btn.disabled = true;
    });

    const bundleItems = this.bundleProducts;
    const bundleProductData = this.bundleProductData;
    const maxPerProduct = this.maxPerProduct;
    let quantityInputs = this.querySelectorAll(
      ".bundle-card .product-card:not(.pf-addon-product-card) .quantity-input"
    );
    let items = [];
    quantityInputs.forEach((input) => {
      const quantity = Number.parseInt(input.value, 10);
      if (!Number.isFinite(quantity) || quantity <= 0) return;
      const card = input.closest(".product-card");
      const id =
        input.getAttribute("product-id") ||
        input.getAttribute("data-product-id") ||
        input.getAttribute("data-pf-product-id") ||
        card?.getAttribute("data-pf-product-id") ||
        input.getAttribute("name")?.match(/\[(\d+)\]/)?.[1] ||
        "";
      const bundleItem = bundleItems.find((e) => String(e.id) === String(id));
      if (quantity > 0) {
        if (!bundleItem) {
          console.warn("RechargeBundle: missing bundleItem for quantity input", id, input);
          return;
        }
        if (maxPerProduct != null) {
          if (quantity > maxPerProduct) {
            return;
          }
        }
        const availableVariant = bundleItem.variants.find((v) => this.isVariantAvailable(v));
        if (!availableVariant) {
          return;
        }
        items.push({
          collectionId: parseInt(bundleItem.collectionId ?? bundleProductData.collectionIds[0], 10),
          externalProductId: bundleItem.id,
          externalVariantId: availableVariant.id,
          quantity: quantity,
          title: bundleItem.title,
        });
      }
    });

    const scheduleSelection = this.getSelectedScheduleSelection();
    const dynamicItems = items.map((i) => {
      const productData = bundleItems.find((bundleItem) => {
        return bundleItem.id === i.externalProductId;
      });
      if (!productData) {
        return i;
      }
      const sellingPlanId = this.resolveSellingPlanIdForProduct(productData, scheduleSelection);
      if (sellingPlanId != null) {
        return { ...i, sellingPlan: sellingPlanId };
      }
      return i;
    });
    console.log("dynamic items", bundleItems, dynamicItems);
    const externalVariantId = this.getSelectedBundleVariantId();
    if (!Number.isFinite(externalVariantId)) {
      console.error("RechargeBundle: missing bundle variant id");
      this.restoreCheckoutButtons();
      return;
    }
    const bundle = {
      externalVariantId,
      externalProductId: parseInt(bundleProductData.productId),
      selections: [...dynamicItems],
    };

    const validationResult = recharge.bundle.validateDynamicBundle(bundle);
    if (validationResult !== true) {
      console.error("RechargeBundle: invalid dynamic bundle", validationResult);
      this.restoreCheckoutButtons();
      return;
    }

    const bundleId = await recharge.bundle.getBundleId(bundle);
    this.bundleId = bundleId;

    const dynamicBundleItems = recharge.bundle.getDynamicBundleItems(
      bundle,
      bundleProductData.handle
    );

    const selectedScheduleText = String(scheduleSelection.label || "")
      .toLowerCase()
      .trim();
    const selectedScheduleValue = String(scheduleSelection.value || "")
      .toLowerCase()
      .trim();

    const cartData = {
      items: [
        ...dynamicBundleItems.map((item, index) => {
          const selection =
            dynamicItems.find((s) => String(s.externalVariantId) === String(item.id)) ||
            dynamicItems[index];
          const perBundleQty = Math.max(
            1,
            Number.parseInt(String(selection?.quantity || item.quantity || 1), 10) || 1
          );
          const cartItem = {
            ...item,
            properties: {
              ...item.properties,
              _rb_id: bundleId,
              _pf_bundle_line_qty: String(perBundleQty),
              "Bundle Id": `bittman_${bundleId}`,
            },
          };

          const productData = this.bundleProducts.find(
            (p) => String(p.id) === String(selection?.externalProductId)
          );
          const sellingPlanGroup = productData?.selling_plan_groups?.find((g) =>
            g.selling_plans?.some(
              (sp) =>
                String(sp.selling_plan_name || "")
                  .toLowerCase()
                  .trim() === selectedScheduleText ||
                (Array.isArray(sp.options)
                  ? sp.options.some(
                      (opt) =>
                        String(opt?.value || "")
                          .toLowerCase()
                          .trim() === selectedScheduleValue
                    )
                  : false)
            )
          );
          const selectedProductPlanId = this.resolveSellingPlanIdForProduct(
            productData,
            scheduleSelection
          );
          const sellingPlanId = selectedProductPlanId || sellingPlanGroup?.selling_plans?.[0]?.id;
          if (
            sellingPlanId != null &&
            Number.isFinite(Number.parseInt(String(sellingPlanId), 10))
          ) {
            cartItem.selling_plan = Number.parseInt(String(sellingPlanId), 10);
          }

          return cartItem;
        }),
      ],
    };
    const selectedDiscountProduct = this.getSelectedDiscountProduct();
    const includeFreeGift = this.shouldIncludeFreeGift();
    if (includeFreeGift) {
      cartData.items.push({
        id: selectedDiscountProduct.variantId,
        quantity: 1,
        properties: {
          _free_butter: true,
          _rb_id: bundleId,
        },
      });
    }
    cartData.items.push(...this.getAddonCartItems());

    try {
      const addResponse = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(cartData),
      });
      if (!addResponse.ok) {
        const errBody = await addResponse.json().catch(() => ({}));
        throw new Error(`Failed to add to cart: ${JSON.stringify(errBody)}`);
      }

      if (this.discountCode && includeFreeGift) {
        await fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ discount: this.discountCode }),
        });
      }

      const newCartRes = await fetch("/cart.js");
      const newCartJson = await newCartRes.json();
      const newCartData = newCartJson.data;
      document.dispatchEvent(
        new CustomEvent(ThemeEvents.cartUpdate, {
          detail: {
            data: {
              ...newCartJson,
              sections: ["component-cart-items", "cart-drawer-component"],
            },
          },
        })
      );
      const checkoutUrl =
        this.discountCode && includeFreeGift
          ? `/checkout?discount=${encodeURIComponent(this.discountCode)}`
          : "/checkout";
      this.pushBundleAddedToCartEvent(items);
      window.location.href = checkoutUrl;
    } catch (error) {
      console.error("Error:", error);
      this.restoreCheckoutButtons();
    }
  }
}

if (!customElements.get("recharge-bundle")) {
  customElements.define("recharge-bundle", RechargeBundle);
}
